import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridRenderCellParams,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import {TableHeaderProps} from "../../../../../utils/types";
import {useEffect, useMemo, useState} from "react";
import {ColumnVisibilityFor} from "../../../../../utils/Enum.Datagrid";
import {
  StyledDatagrid,
  useDataGridStyles,
} from "../../../../../styles/DatagridStyles";

import NoData from "../../../../../images/NoData.svg";
import Copy from "../../../../../images/Copy.svg";
import {useLazyQuery} from "@apollo/client";
import {GetProjectsHeaders} from "../../masters/projects/queries/queries";
import {
  GetProjectsHeadersResult,
  GetProjectsHeadersVar,
} from "../../masters/projects/queries/types";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
} from "../../../../../styles/Variables";
const TableStructureList = () => {
  const {WorkInProgress} = useAssetTableJson();
  const {headerStyles} = useDataGridStyles();
  const {customer_id, projectID} = useUrlParams();
  const [GetHeaders, {data}] = useLazyQuery<
    GetProjectsHeadersResult,
    GetProjectsHeadersVar
  >(GetProjectsHeaders);

  useEffect(() => {
    if (customer_id && projectID) {
      GetHeaders({
        variables: {
          customerID: customer_id,
          projectID: projectID,
        },
      });
    }
  }, [customer_id, projectID, GetHeaders]);

  const staticHeader: TableHeaderProps[] = WorkInProgress.ProjectStatus.filter(
    (header) =>
      header.field !== "pmu_remarks" &&
      header.field !== "date" &&
      header.field !== "id"
  ).map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: (params: GridRenderCellParams) => {
      if (header.field === "status") {
        return (
          <>
            <span
              className={
                params.row.status === "updated" ? "updated" : "not-updated"
              }
            >
              {params.row.status}
            </span>
          </>
        );
      }

      return params.value;
    },
  }));

  const columns = useMemo(() => {
    if (data && data.GetProjectsHeaders) {
      return [
        ...staticHeader.slice(0, 2),
        ...data.GetProjectsHeaders.map((header) => ({
          headerName: header.header,
          field: header.header,
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          hideable: true,
          cellClassName: "",
          flex:1
        })),
        ...staticHeader.slice(2),
      ];
    } else {
      return staticHeader;
    }
  }, [data, staticHeader]);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({
      id: true,
      date: true,
      quantity: true,
      foundation_completed: true,
      it_hardware_installation: true,
      pending_work: true,
      completed_go_live: true,
      remarks: false,
      status: true,
      pmu_remarks: true,
    });

  const rows: GridValidRowModel[] = [
    {
      id: 1,
      date: "05-06-2025",
      quantity: 0,
      foundation_completed: 0,
      it_hardware_installation: 0,
      pending_work: 0,
      completed_go_live: 0,
      remarks: "work In Progress",
      status: "updated",
      pmu_remarks: "",
    },
  ];

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.WORK_IN_PROGRESS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      ColumnVisibilityFor.WORK_IN_PROGRESS,
      JSON.stringify(columnVisibilityModel)
    );
  }, [columnVisibilityModel]);
  return (
    <>
      {/* <div className="wp-project-details__block--row row g-0">
        <div className="col"></div>

        <div className="col-2 flex-end">
          <button className="wp-project-details__block--copy">
            <img src={Copy} alt="" />
            Copy Table Format
          </button>
        </div>
      </div> */}

      <div className="wp-project-details__block--table">
        {rows.length ? (
          <>
            <StyledDatagrid
              columns={columns}
              rows={rows}
              disableRowSelectionOnClick
              hideFooter
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) =>
                setColumnVisibilityModel(newModel)
              }
              getRowHeight={() => "auto"}
      
            />
          </>
        ) : (
          <>
            <img src={NoData} alt="" className="nodata-image" />
          </>
        )}
      </div>
    </>
  );
};

export default TableStructureList;
